import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Box, ThemeProvider, Typography, Link } from '@mui/material';
import theme from './theme';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Gallery from './pages/Gallery';
import DiscountCodes from './pages/DiscountCodes';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Box sx={{ 
          minHeight: '100vh', 
          display: 'flex', 
          flexDirection: 'column',
          backgroundColor: theme.palette.background.default, // Darkest brand color
          color: theme.palette.text.primary
        }}>
          <Navbar />
          <Box component="main" sx={{ 
            flexGrow: 1,
            backgroundColor: theme.palette.background.default
          }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/DiscountCodes" element={<DiscountCodes />} />
            </Routes>
          </Box>
          
          {/* Footer */}
          <Box 
            component="footer" 
            sx={{ 
              backgroundColor: theme.palette.primary.dark,
              padding: '1rem',
              textAlign: 'center',
              borderTop: '2px dashed',
              borderColor: theme.palette.text.secondary,
              marginTop: 'auto'
            }}
          >
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
              Website created by{' '}
              <Link 
                href="https://akaifuwa.com" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ 
                  color: theme.palette.primary.main,
                  textDecoration: 'none',
                  '&:hover': {
                    color: theme.palette.text.primary,
                    textDecoration: 'underline'
                  }
                }}
              >
                akaifuwa
              </Link>
            </Typography>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;